import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import { listProjects } from "../../lib/projectApi";
import { Folder, FileCode, RefreshCw } from "lucide-react";

export default function OpenProjectModal({ open, onClose, onPick }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  async function refresh() {
    setLoading(true);
    setErr("");
    try {
      const data = await listProjects(50, 0);
      setItems(data.projects || []);
    } catch (e) {
      setErr(e.message || "load failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (open) refresh();
  }, [open]);

  return (
    <Modal
      open={open}
      title="Open project"
      onClose={onClose}
      width={520}
      footer={
        <>
          <button className="ide-button" onClick={refresh} disabled={loading}>
            <RefreshCw className={"h-3.5 w-3.5 " + (loading ? "animate-spin" : "")} />
            Refresh
          </button>
          <button className="ide-button" onClick={onClose}>Close</button>
        </>
      }
    >
      {err && <div className="text-rose-300 text-sm mb-2">{err}</div>}
      {loading && items.length === 0 && (
        <div className="text-ide-mute text-sm py-6 text-center">Loading\u2026</div>
      )}
      {!loading && items.length === 0 && !err && (
        <div className="text-ide-mute text-sm py-6 text-center">
          No saved projects yet. Use “Save As…” to create one.
        </div>
      )}
      <div className="max-h-[420px] overflow-auto -mx-1">
        {items.map((p) => (
          <button
            key={p.id}
            className="flex items-start gap-3 w-full px-3 py-2 rounded hover:bg-ide-surface transition-colors text-left"
            onClick={() => { onPick?.(p.id); onClose?.(); }}
          >
            <div className="flex-none mt-0.5">
              {p.language === "html" ? (
                <Folder className="h-4 w-4 text-purple-300" />
              ) : (
                <FileCode className="h-4 w-4 text-sky-300" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-ide-text truncate">{p.name}</span>
                {p.name.startsWith("Example:") && (
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-500/15 text-emerald-300 border border-emerald-500/30">
                    example
                  </span>
                )}
              </div>
              <div className="text-[11px] text-ide-mute font-mono">
                {p.language} · {new Date(p.updated_at).toLocaleString()}
              </div>
            </div>
          </button>
        ))}
      </div>
    </Modal>
  );
}
